export const contactInfo = [
  "401 E 8TH Street, Suite 1716",
  "Sioux Falls, SD 57103",
  "(774) 326-4361",
  "hello@smartawnings.com"
];

export const storeLinks = [
  {
    name: 'Luminous valances',
    path: '/luminous-valances',
  },
  /*{
    name: 'Stores extérieurs',
    path: '/store',
  },
  {
    name: 'Pergolas',
    path: '/pergola',
  },
  {
    name: 'Enseignes',
    path: '/enseigne',
  },
  {
    name: 'Claustras',
    path: '/claustras',
  },
  {
    name: 'Radiants',
    path: '/radiants',
  },*/
];

export const otherLinks = [
  {
    name: 'Our references',
    path: '/our-references',
  },
  {
    name: 'Who are we?',
    path: '/who-we-are',
  },
  {
    name: 'F.A.Q.',
    path: '/faq',
  },
  {
    name: 'Contact',
    path: '/contact',
  },
]
